import { useAppSelector } from '../../store';
import Announcement from './Announcement';

import styles from './AnnouncementCenter.module.css';

/**
 * Component that manages the applications announcements.
 * @returns
 */
export default function AnnouncementCenter() {
	const announcements = useAppSelector((state) => state.announcementState.announcements);
	const renderAnnouncement = announcements.length > 0 ? announcements[0] : undefined;

	if (renderAnnouncement) {
		return (
			<div className={styles.root}>
				<Announcement
					key={renderAnnouncement.uniqueId}
					{...renderAnnouncement}
				/>
			</div>
		);
	}

	return <></>;
}
